import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-black">
      {/* Social Media Section */}
      <div className="bg-dark text-white py-8">
        <div className="section-container text-center">
          <h4 className="text-xl font-semibold mb-4">FØLG OS PÅ</h4>
          <div className="flex justify-center gap-6">
            <a 
              href="https://www.instagram.com/murermester_voss/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform"
              aria-label="Instagram"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.849.07 1.366.062 2.633.344 3.608 1.32.974.975 1.256 2.242 1.318 3.608.058 1.265.069 1.645.069 4.849s-.012 3.584-.07 4.849c-.062 1.366-.344 2.633-1.32 3.608-.975.974-2.242 1.256-3.608 1.318-1.265.058-1.645.069-4.849.069s-3.584-.012-4.849-.07c-1.366-.062-2.633-.344-3.608-1.32-.974-.975-1.256-2.242-1.318-3.608-.058-1.265-.069-1.645-.069-4.849s.012-3.584.07-4.849c.062-1.366.344-2.633 1.32-3.608.975-.974 2.242-1.256 3.608-1.318C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.736 0 8.332.015 7.052.072c-1.591.07-2.993.38-4.148 1.536C1.747 2.757 1.438 4.16 1.368 5.752.31 7.032.295 7.436.295 11s.015 3.968.072 5.248c.07 1.591.38 2.993 1.536 4.148 1.155 1.155 2.557 1.465 4.148 1.536C8.332 23.985 8.736 24 12 24s3.668-.015 4.948-.072c1.591-.07 2.993-.38 4.148-1.536 1.155-1.155 1.465-2.557 1.536-4.148.057-1.28.072-1.684.072-5.248s-.015-3.968-.072-5.248c-.07-1.591-.38-2.993-1.536-4.148C19.928 1.747 18.526 1.437 16.935 1.368 15.655.31 15.251.295 12 .295z"/>
                <circle cx="12" cy="12" r="3.5"/>
                <circle cx="18.406" cy="5.594" r="1.44"/>
              </svg>
            </a>
            <a 
              href="https://www.facebook.com/profile.php?id=61573888060525" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:scale-110 transition-transform"
              aria-label="Facebook"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.465.099 2.795.143v3.243h-1.918c-1.504 0-1.796.715-1.796 1.763v2.309h3.59l-.467 3.622h-3.123V24h6.116c.729 0 1.324-.593 1.324-1.324V1.325C24 .593 23.407 0 22.675 0z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="section-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* Location */}
          <div>
            <h4 className="text-xl font-semibold mb-4">FIND OS</h4>
            <p className="mb-4">Søgårdsvej 7 ​4550 Asnæs</p>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d140737.385345816!2d11.589001900260293!3d55.59960555879201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465286c62ef9b123%3A0x95fb40af22d48a5f!2s4350%20Ugerl%C3%B8se%2C%20Denmark!5e0!3m2!1sen!2smk!4v1742208625271!5m2!1sen!2smk"
              width="150" 
              height="150" 
              className="border-0 mx-auto md:mx-0"
              allowFullScreen="" 
              loading="lazy"
              title="Location Map"
            />
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xl font-semibold mb-4">SKRIV TIL OS</h4>
            <p className="mb-2">Murervoss25@hotmail.com
</p>
            <a href="tel:+4528588607" className="text-primary hover:text-secondary transition-colors">
              <p>DK: +45 28 55 25 83</p>
            </a>
          </div>

          {/* Legal */}
          <div>
            <Link to="/privatpolitik">
              <button className="btn-primary mb-4">Privatpolitik</button>
            </Link>
            <h4 className="text-xl font-semibold mb-2">CVR: 498786732312</h4>
            <p className="text-xs">
              © 2025 Murermester Voss.
              <br />Alle rettigheder forbeholdes.
            </p>
          </div>
        </div>
      </div>


    </footer>
  );
};

export default Footer;
